import { ToggleGroup, ToggleGroupItem } from "src/components/ui/toggle-group";
import { cn } from "src/lib/utils";

const options = [
  { value: "noComparison", label: "None", accessibleLabel: "No comparison" },
  { value: "previousPeriod", label: "Previous period" },
  { value: "previousYear", label: "Previous year" },
];

export function ComparisonRangePicker({
  disabled,
  disabledValues = [],
  className,
  value,
  setValue,
}) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(next) => {
        if (next) setValue(next);
      }}
      disabled={disabled}
      variant="outline"
      size="sm"
      aria-label="Compare with"
      className={cn("h-9 w-full", className)}
    >
      {options.map((option) => (
        <ToggleGroupItem
          key={option.value}
          value={option.value}
          aria-label={option.accessibleLabel || option.label}
          disabled={disabled || disabledValues.includes(option.value)}
          className="h-9 flex-auto px-2 text-xs data-[state=on]:bg-primary/10 data-[state=on]:text-primary"
        >
          {option.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
